// src/components/PerformanceChart.js
// src/components/PerformanceChart.js
// src/components/PerformanceChart.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const PerformanceChart_old = ({ performanceData, showLegend = true, yAxisLabel = '' }) => {
  const formattedData = Array.isArray(performanceData)
  ? performanceData.map(item => ({
      year: item.year,
      value: item.annualValue,
    }))
  : [];


  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={formattedData}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="year" />
        <YAxis label={{ value: yAxisLabel, angle: -90, position: 'insideLeft' }} />
        <Tooltip />
        {showLegend && <Legend />}
        <Bar dataKey="value" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default PerformanceChart_old;


